import { BellIcon, MultiSelectIcon } from '@primer/octicons-react';
import { Box, Octicon, Tooltip } from '@primer/react';
import { useEffect, useState } from 'react';
import ComboBoxDiemDanhStatus from '../../components/combobox-diemdanh-status';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import TimeEdit from '../../components/time-edit';
import Button from '../../components/ui/button';
import DataTable from '../../components/ui/data-table';
import { IFocusCell } from '../../components/ui/data-table/DataTable';
import Modal from '../../components/ui/modal';
import ModalActions from '../../components/ui/modal/ModalActions';
import TextInput from '../../components/ui/text-input';
import { useCommonContext } from '../../contexts/common';
import { useLanguage } from '../../hooks/useLanguage';
import { ePageBaseStatus } from '../../models/ePageBaseStatus';
import { IDiemDanhPhongNamHocChangeRequest } from '../../models/request/diem-danh/IDiemDanhPhongNamHocChangeRequest';
import { DiemDanhResponse } from '../../models/response/diem-danh/DiemDanhResponse';
import { IPhongDiemDanhResponse } from '../../models/response/diem-danh/IPhongDiemDanhResponse';
import { actions } from '../../state/actions/actionsWrapper';
import { RootState } from '../../state/reducers';
import DiemDanhStatus from './DiemDanhStatus';
import { diemDanhStatusApi } from '../../api/diemDanhStatusApi';
import { set } from 'react-hook-form';
import { useTrangThaiDiemDanh } from '../../hooks/useTrangThaiDiemDanh';
import Text from '../../components/ui/text';
interface IDiemDanhAllModalProps {
    date: string,
    phongDiemDanh: IPhongDiemDanhResponse,
    onClose: () => void,
    data: DiemDanhResponse[]
}
const DiemDanhAllModal = (props: IDiemDanhAllModalProps) => {
    const { translate } = useCommonContext();
    const [showDanThuocInfoIdModal, setShowDanThuocInfoIdModal] = useState(0);
    const { language } = useLanguage();
    const [focusedCell, setFocusedCell] = useState<IFocusCell>();
    const [formData, setFormData] = useState(props.data);
    const dispatch = useDispatch();
    const { nt_diem_danh_trang_thais } = useTrangThaiDiemDanh();
    const [statusAll, setStatusAll] = useState<number>(nt_diem_danh_trang_thais.find(x => x.is_default == true)?.id ?? 0);
    const { status } = useSelector(
        (state: RootState) => state.diemDanh
    );

    useEffect(() => {
        const curentTime = moment().format("HH:mm");
        setFormData(props.data.map(x => {
            const defaultStatusId = nt_diem_danh_trang_thais.find(x => x.is_default)?.id ?? 1;
            const defaultStatus = x.sis_diemdanh_status_id > 0 ? x.sis_diemdanh_status_id : defaultStatusId;
            const diemDanhStatus = nt_diem_danh_trang_thais.find(a => a.id === defaultStatus);
            let gioDiemDanh = !!props.phongDiemDanh.gio_diem_danh ? props.phongDiemDanh.gio_diem_danh : curentTime
            return {
                ...x,
                sis_diemdanh_status_id: x.sis_diemdanh_status_id > 0 ? x.sis_diemdanh_status_id : defaultStatusId,
                sis_diemdanh_status_name: x.id > 0 ? x.sis_diemdanh_status_name : (diemDanhStatus?.name ?? ""),
                sis_diemdanh_status_name_en: x.id > 0 ? x.sis_diemdanh_status_name_en : (diemDanhStatus?.name_en ?? ""),
                gio_diem_danh: x.id > 0 ? x.gio_diem_danh : gioDiemDanh
            }
        }))
    }, [props.data, nt_diem_danh_trang_thais]);

    const handleSubmit = () => {
        handelSubmitDiemDanh();
    }
    const handelSubmitDiemDanh = () => {
        const updateDiemDanhModel: IDiemDanhPhongNamHocChangeRequest = {
            ngay_diem_danh: props.date,
            noitru_phong_namhoc_id: props.phongDiemDanh.phong_nam_hoc_id,
            dm_truong_id: 0,
            nt_tiet_id: props.phongDiemDanh.nt_tiet_id,
            nt_thoi_khoa_bieu_chi_tiet_id: props.phongDiemDanh.nt_thoi_khoa_bieu_chi_tiet_id,
            ts_hocsinhs: formData.map((hoc_sinh) => ({
                ts_hocsinh_id: hoc_sinh.ts_hocsinh_id,
                dm_lop_id: hoc_sinh.dm_lop_id,
                sis_diemdanh_status_id: hoc_sinh.sis_diemdanh_status_id,
                ghi_chu: hoc_sinh.ghi_chu,
                gio_diem_danh: hoc_sinh.gio_diem_danh,
            }))

        };
        dispatch(actions.diemDanh.diemDanhPhongNamHocStart(updateDiemDanhModel));
    }

    return (
        <>

            <Modal
                isOpen={true}
                title={props.phongDiemDanh.ten_phong}
                onClose={props.onClose}
                width={"70%"}
            >
                <Box>
                    <DataTable
                        columns={[
                            {
                                caption: translate('Base.Label.StudentCode'),
                                dataField: 'ma_hs',
                                width: "150px",
                                cellRender: (data: DiemDanhResponse) => {
                                    return (
                                        <Box>
                                            <Box sx={{
                                                color: "fg.muted"
                                            }}>{data.ma_hs}</Box>
                                        </Box>
                                    );
                                }
                            },
                            {
                                caption: translate('Base.Label.StudentName'),
                                dataField: 'ho_ten',
                                width: "200px",
                                cellRender: (data: DiemDanhResponse) => {
                                    return (
                                        <Box>
                                            <Box><b>{data.ho_ten}</b></Box>
                                        </Box>
                                    );
                                }
                            },
                            {
                                caption: translate('Base.Label.ClassName'),
                                dataField: 'ten_lop_hc',
                                width: "80px",
                                align: "center"
                            },

                            {
                                caption: translate('Base.Label.Status'),
                                dataField: 'sis_diemdanh_status_name',
                                width: "170px",
                                align: "center",
                                isAllowFocus: true,
                                cellRender: (data: DiemDanhResponse) => {
                                    const value = language === "en" ? data.sis_diemdanh_status_name_en : data.sis_diemdanh_status_name;
                                    const isFocused = focusedCell && (focusedCell.dataField === 'sis_diemdanh_status_name') && focusedCell.rowData.id === data.id;
                                    return (
                                        <Box>
                                            {isFocused &&
                                                <>
                                                    <ComboBoxDiemDanhStatus
                                                        isNoborder={true}
                                                        onValueChanged={(id, value) => {
                                                            setFormData(formData.map(x => {
                                                                if (x.id === data.id) {
                                                                    return {
                                                                        ...x,
                                                                        sis_diemdanh_status_id: id,
                                                                        sis_diemdanh_status_name_en: value?.name_en ?? "",
                                                                        sis_diemdanh_status_name: value?.name ?? "",
                                                                    };
                                                                }
                                                                return {
                                                                    ...x
                                                                };
                                                            }))
                                                        }}
                                                        value={data.sis_diemdanh_status_id}
                                                    />
                                                </>
                                            }
                                            {!isFocused &&
                                                <>
                                                    <DiemDanhStatus
                                                        name={language === "en" ? data.sis_diemdanh_status_name_en : data.sis_diemdanh_status_name}
                                                        id={data.sis_diemdanh_status_id}
                                                    />
                                                </>
                                            }
                                        </Box>
                                    );
                                }
                            },
                            {
                                dataField: 'gio_diem_danh',
                                caption: translate('DiemDanhHocSinhPage.Grid.AttendanceTime'),
                                width: "100px",
                                align: "center",
                                isAllowFocus: true,
                                cellRender: (data: DiemDanhResponse) => {
                                    const value = data.gio_diem_danh ?? ""
                                    const isFocused = focusedCell && (focusedCell.dataField === 'gio_diem_danh') && focusedCell.rowData.id === data.id;
                                    return (
                                        <Box>
                                            {isFocused &&
                                                <>
                                                    <TimeEdit
                                                        value={value}
                                                        isNoborder={true}
                                                        onValueChanged={(value) => {
                                                            setFormData(formData.map(x => {
                                                                if (x.id === data.id) {
                                                                    return {
                                                                        ...x,
                                                                        gio_diem_danh: value

                                                                    };
                                                                }
                                                                return {
                                                                    ...x
                                                                };
                                                            }))

                                                        }}
                                                    />
                                                </>
                                            }
                                            {!isFocused &&
                                                <>{value ? (value.length > 5 ? value.substring(0, 5) : value) : ""}</>
                                            }
                                        </Box>
                                    );
                                }
                            },
                            {
                                dataField: 'ghi_chu',
                                caption: translate('Base.Label.Note'),
                                minWidth: "150px",
                                align: "center",
                                isAllowFocus: true,
                                cellRender: (data: DiemDanhResponse) => {
                                    const isFocused = focusedCell && (focusedCell.dataField === 'ghi_chu') && focusedCell.rowData.id === data.id;
                                    return (
                                        <Box>
                                            {isFocused &&
                                                <>
                                                    <TextInput
                                                        block
                                                        sx={{
                                                            width: "100%",
                                                            border: "none"
                                                        }}
                                                        defaultValue={data.ghi_chu}
                                                        onBlur={(e) => {
                                                            setFormData(formData.map(x => {
                                                                if (x.id === data.id) {
                                                                    return {
                                                                        ...x,
                                                                        ghi_chu: e.target.value

                                                                    };
                                                                }
                                                                return {
                                                                    ...x
                                                                };
                                                            }))

                                                        }}
                                                    />
                                                </>
                                            }
                                            {!isFocused &&
                                                <>{data.ghi_chu}</>
                                            }

                                        </Box>
                                    );
                                }
                            },
                            {
                                caption: translate('Base.Label.NotifyStatus'),
                                dataField: 'app_notify_id',
                                width: "100px",
                                align: "center",
                                cellRender: (data: DiemDanhResponse) => {
                                    return (
                                        <>
                                            {data.app_notify_id > 0 &&
                                                <Tooltip direction="n" aria-label={translate('Base.Label.IsSentNotify')}>
                                                    <Octicon icon={BellIcon} sx={{
                                                        color: "success.fg"
                                                    }} />
                                                </Tooltip>
                                            }
                                        </>
                                    );
                                }
                            },
                        ]}
                        height={`${window.innerHeight - 210}px`}
                        data={formData}
                        onFocuseCellChanged={(data) => {
                            setFocusedCell(data)
                        }}
                        focusedCell={focusedCell}
                        checkDontSaveChange={{
                            fields: ["sis_diemdanh_status_id", "gio_diem_danh", "ghi_chu"],
                            rootDataSource: props.data
                        }}
                        actionComponent={
                            <Box sx={{
                                display: "flex"
                            }}>
                                <Box sx={{display: 'flex', gap: 2, justifyContent: 'center', alignItems: 'center'}}>
                                    <Text text='Trạng thái cả phòng' sx={{fontWeight: 700}}/>
                                    <ComboBoxDiemDanhStatus
                                        width={'100%'}
                                        value={statusAll}
                                        onValueChanged={(value) => {
                                            setStatusAll(value);
                                            debugger
                                            let status = nt_diem_danh_trang_thais.find(x => x.id == value);
                                            setFormData((prev) =>
                                                formData
                                                    .map((item) => ({
                                                        ...item,
                                                        sis_diemdanh_status_id: status?.id ?? 0,
                                                        sis_diemdanh_status_name_en: status?.name_en ?? "",
                                                        sis_diemdanh_status_name: status?.name ?? "",
                                                    }))
                                            );
                                            console.log(formData
                                                    .map((item) => ({
                                                        ...item,
                                                        sis_diemdanh_status_id: status?.id ?? 0,
                                                        sis_diemdanh_status_name_en: status?.name_en ?? "",
                                                        sis_diemdanh_status_name: status?.name ?? "",
                                                    })))
                                        }}
                                    />
                                </Box>
                            </Box>
                        }
                    />
                </Box>
                <ModalActions>
                    <Button text='Base.Label.Close' onClick={() => {
                        props.onClose();
                    }} />
                    <Button text='DiemDanhModal.Button.Update' variant='primary' onClick={handleSubmit}
                        leadingVisual={MultiSelectIcon}
                        isLoading={status === ePageBaseStatus.is_saving}
                    />
                </ModalActions>
            </Modal>
            {showDanThuocInfoIdModal > 0 &&
                <Modal
                    title={translate("DanhThuocPage.Caption")}
                    isOpen={true}
                    onClose={() => {
                        setShowDanThuocInfoIdModal(0)
                    }}
                >
                    <Box>
                        {/* <DanThuocInfo id={showDanThuocInfoIdModal} /> */}
                    </Box>
                    <ModalActions>
                        <Button text='Base.Label.Close'
                            onClick={() => {
                                setShowDanThuocInfoIdModal(0)
                            }}
                        />
                    </ModalActions>
                </Modal>
            }
        </>
    );
};

export default DiemDanhAllModal;